<template>
    <div class="animated fadeIn" id="horas-fabrica-devs">
        <div class="card card-default">
            <div class="card-header">
                <div class="card-header">
                    <i class="fa fa-money"></i> Horas Fábrica Devs
                </div>
            </div>
            <div class="card-body">
                <div class="input-group mb-3 align-items-center" style="gap: 10px;">
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Competência
                    </span>
                    <date-picker
                        v-model="competencia"
                        format="MM/YYYY"
                        type="month"
                        lang="pt-br"
                        input-class="form-control datepicker-custom input-custom"
                        style="width: 260px; margin-right: 8px;"
                    />
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Status
                    </span>
                    <select
                        class="form-control input-custom"
                        v-model="status"
                        style="width: 180px; max-width: 180px; flex: 0 0 180px; height: 40px; margin-right: 8px;">
                        <option :value="1">Todos</option>
                        <option :value="2">Fechado</option>
                        <option :value="3">Abertas</option>
                    </select>
                </div>
                
                <div class="d-flex justify-content-end">
                    <button class="btn btn-primary" style="height: 40px;" @click="pesquisar" :disabled="!competenciaFormatada">
                        <i class="icon-magnifier"></i> Pesquisar
                    </button>
                </div>
                <div v-if="demandas.length > 0" class="mt-4">
                    <table class="table table-bordered table-striped table-sm text-center align-middle">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Título</th>
                                <th>Orçado</th>
                                <th>Atuado</th>
                                <th>% Desenv. Gasto</th>
                                <th>Concluída</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(demanda, idx) in demandas">
                                <tr :key="`demanda-${idx}`">
                                    <td>
                                        <span
                                            style="cursor:pointer; color:#007bff;"
                                            @click="toggleExpandDemanda(demanda.id)">
                                            {{ demanda.id }}
                                        </span>
                                    </td>
                                    <td
                                        style="max-width: 420px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: left;"
                                        :title="demanda.titulo">
                                        {{ demanda.titulo && demanda.titulo.length > 120 ? demanda.titulo.slice(0, 117) + '...' : demanda.titulo }}
                                    </td>
                                    <td>{{ demanda.orcado }}</td>
                                    <td>{{ demanda.total_atuacao }}</td>
                                    <td :style="{ color: corPorcentagemDesenvolvimento(demanda.porcentagem_desenvolvimento_gasto), fontWeight: '600' }">
                                        {{ demanda.porcentagem_desenvolvimento_gasto }}
                                    </td>
                                    <td>
                                        <i
                                            v-if="isConcluida(demanda.status)"
                                            class="fa fa-check"
                                            style="color: #28a745; font-size: 16px;"
                                            title="Concluída"
                                        ></i>
                                        <i
                                            v-else
                                            class="fa fa-times"
                                            style="color: #dc3545; font-size: 16px;"
                                            title="Não concluída"
                                        ></i>
                                    </td>
                                </tr>
                                <tr
                                    v-if="usuariosPorDemanda[demanda.id] && usuariosPorDemanda[demanda.id].length > 0"
                                    :key="`usuarios-row-${demanda.id}`">
                                    <td colspan="100%">
                                        <table class="table table-bordered table-sm" style="margin-bottom:0;">
                                            <thead>
                                                <tr>
                                                    <th>Usuário</th>
                                                    <th>Horas Gastas</th>
                                                    <th>% Participação</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(usuario, uidx) in usuariosPorDemanda[demanda.id]"
                                                    :key="`usuario-${demanda.id}-${usuario.usuario_id || uidx}`">
                                                    <td>{{ usuario.nome }}</td>
                                                    <td>{{ usuario.horas_gastas }}</td>
                                                    <td>{{ usuario.porcentagem_participacao_desenvolvimento }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
    name: 'HorasFabricaDevsIndex',
    components: {
        DatePicker,
    },
    data() {
        return {
            competencia: null,
            status: 1,
            demandas: [],
            demandasExpandido: [],
            usuariosPorDemanda: {},
        };
    },
    computed: {
        competenciaFormatada() {
            if (!this.competencia) {
                return "";
            }
            const data = new Date(this.competencia);
            const mes = String(data.getMonth() + 1).padStart(2, "0");
            const ano = data.getFullYear();
            return `${mes}-${ano}`;
        },
    },
    methods: {
        isConcluida(valor) {
            return valor === true || valor === 1 || valor === "1";
        },
        corPorcentagemDesenvolvimento(valor) {
            const porcentagem = parseFloat(valor);
            if (isNaN(porcentagem)) {
                return "#333";
            }
            if (porcentagem >= 100) {
                return "#dc3545";
            }
            if (porcentagem >= 80) {
                return "#d4a017";
            }
            if (porcentagem >= 35) {
                return "#28a745";
            }
            return "#0056b3";
        },
        pesquisar() {
            this.usuariosPorDemanda = {};
            this.demandasExpandido = [];
            this.buscaDemandasCompetencia();
        },
        async buscaDemandasCompetencia() {
            try {
                const response = await this.$http.get("/faturamento/demandas-competencia", {
                    params: {
                        competencia: this.competenciaFormatada,
                        status: this.status,
                    },
                });
                this.demandas = Array.isArray(response.data.demandas) ? response.data.demandas : [];
            } catch (error) {
                console.error("Erro ao buscar demandas da competência:", error);
                this.demandas = [];
            }
        },
        async toggleExpandDemanda(demandaId) {
            const idx = this.demandasExpandido.indexOf(demandaId);
            if (idx === -1) {
                this.demandasExpandido.push(demandaId);
                await this.buscarUsuariosPorDemanda(demandaId);
            } else {
                this.demandasExpandido.splice(idx, 1);
                this.$delete(this.usuariosPorDemanda, demandaId);
            }
        },
        async buscarUsuariosPorDemanda(demandaId) {
            try {
                const response = await this.$http.get("/faturamento/demanda-usuarios-horas", {
                    params: {
                        demanda_id: demandaId,
                    },
                });
                this.$set(this.usuariosPorDemanda, demandaId, response.data.usuarios || []);
            } catch (error) {
                console.error("Erro ao buscar usuários da demanda:", error);
                this.$set(this.usuariosPorDemanda, demandaId, []);
            }
        },
    },
};
</script>

<style>
.input-group-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-size: 14px;
    height: 40px;
}

.datepicker-custom {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    font-size: 14px;
}

.input-custom,
.input-custom .form-control,
.input-custom input,
.input-custom .datepicker-custom {
    background: #fff !important;
    border: 1px solid #dde2e7 !important;
    color: #333 !important;
    border-radius: 4px !important;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 14px !important;
    box-shadow: none !important;
}

.input-custom input:focus,
.input-custom .form-control:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #a0a0a0 !important;
}
</style>
